import React from 'react';
import { Row, Col, Container, Table } from 'reactstrap';
import { T } from '../traks';
import I18N from '../I18N';
import { Apify, ApifyFullScreenLoadingComponent } from '../Apify';
import ChangeArrow from './ChangeArrow'; 
import API from '../API';

function calcDeltaMoney(value, initial) {
  return value - initial;
}
function calcDeltaPct(value, initial) {
  if (!initial) return 0;
  return ((value / initial) - 1) * 100;
}

export const PublicLeaderboard = Apify('/z/game_public')
  .with_query_from_props(props => ({ game_id: props.gameId }))
  .with_response_prop('game')
  .wrap((props) => {
    if (!props.game) return null;
    const [lastUpdated, setLastUpdated] = React.useState(null);
    const portfolios = [...props.game.Portfolios].sort((a, b) => b.Value - a.Value);

    React.useEffect(() => {
      API.get("/z/last_leaderboard_update", {}, (response, status) => {
        if (status >= 200 && status < 300) {
          const ts = response.replace(/(^"|"$)/g, "").trim();
          setLastUpdated(new Date(ts));
        } else {
          console.error("Error fetching last leaderboard update:", status);
        }
      });
    }, []);

    return (
        <React.Fragment>
        <Row className='ad_game_box'>
          <Col xs="12" className="py-3">
            <div className="pb-0 ad_150pct mr-auto">
                <span className="fw-bold"><T>Leaderboard</T></span> - Millionærklubbens Aktiespil
            </div>
            {lastUpdated && (
                <span className='ad_90pct fst-italic text-muted'>
                  Sidst opdateret: {lastUpdated.toLocaleString("da-DK")}
                </span>
              )}
            <div className="d-flex align-items-center justify-content-between pb-0">
                <div></div>
                  <a href="/leaderboard_full" className="txt-color-green">
                    Se alle
                  </a>	
                </div>
          </Col>
        </Row>
        <Row>
          <Col xs="12">
            <Table className="ad_leader_board bg-color-white">
              <thead>
                <tr>
                  <th className="ad_th_1px"/>
                  <th><span className="ad_game_table_header font-s pl-3"><T>NAME</T></span></th>
                  <th className="d-none d-sm-table-cell"><span className="ad_game_table_header font-s"><T>TRADES</T></span></th>
                  <th className="d-none d-sm-table-cell"><span className="ad_game_table_header font-s"><T>TOTAL CHANGE</T></span></th>
                  <th className="text-end"><span className="ad_game_table_header font-s"><T>VALUE</T></span></th>
                </tr>
              </thead>
              <tbody>
                {portfolios.map((p, i) => {
                  const delta_money = calcDeltaMoney(p.Value, props.game.InitialAmount);
                  const delta_pct = calcDeltaPct(p.Value, props.game.InitialAmount);
                  const suffix = ` (${Number(delta_pct).toFixed(2)}%)`;

                  let row_class = "ad_game_table_border ad_grey_hover";

                  return (
                    <tr
                    className={row_class}
                    key={p.Id}
                    style={{ cursor: 'pointer', userSelect: 'none' }}
                    onClick={() => window.location.href = `/portfolio/${p.Id}`}
                    tabIndex={0}
                    onKeyDown={e => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        window.location.href = `/portfolio/${p.Id}`;
                      }
                    }}
                    role="button"
                    aria-label={`Go to portfolio for ${p.OwnerScreenName}`}
                  >
                    <td className="text-right fw-bold">{i + 1}</td>
                    <td className="pl-4 mr-0 align-middle table-cell-min py-md-2 fw-bold">
                      <span className="text-overflow-dynamic-container">
                        <span className="text-overflow-dynamic-ellipsis">{p.OwnerScreenName}</span>
                      </span>
                    </td>
                    <td className="d-none d-sm-table-cell fw-bold txt-color-dark-black">
                      <span>{p.TradesCount}</span>
                    </td>
                    <td className="d-none d-sm-table-cell fw-bold">
                      <ChangeArrow currency_unit={props.game.Currency} pct={delta_money} suffix={suffix} />
                    </td>
                    <td className="text-end fw-bold">
                      <span>
                        {I18N.floatval_unit(p.Value, 2, props.game.Currency)}
                      </span>
                    </td>
                  </tr>
                );
                })}
              </tbody>
            </Table>
          </Col>
        </Row>
      </React.Fragment>
    );
  }, ApifyFullScreenLoadingComponent);


// WEBPACK FOOTER //
// ./src/c/PublicLeaderboard.js